import { FC, useState, useContext, useEffect } from 'react'
import Head from 'next/head'

import statisticContext from 'context/statisticsContext'
import WebinarActive from '../webinar-active/webinar-active'
import WebinarFuture from '../webinar-future/webinar-future'
import WebinarSocketWrap from '../webinar-with-socket/webinar-socket-wrap'
import useLectorsSubscription from 'hooks/useLectorsSubscription'

import { PLACEFLAG_FUTURE, PLACEFLAG_LIVE, AnalyticWebinarPlace } from 'constants/analytic-data'
import { IMaterial } from 'constants/types/webinar.types'
import { StatusVocabulary } from 'constants/data'
import { ISEOContext } from 'constants/types/common.types'
import { SocketEvents } from 'constants/events'

interface WebinarWithSocket {
  webinarData: IMaterial
  setSEOData: (seo: any) => void
}

const WebinarWithSocket: FC<WebinarWithSocket> = ({ webinarData, setSEOData }) => {
  //TODO перенести все состояние в редакс
  const statisticSocket = useContext(statisticContext)
  const [webinar, setWebinar] = useState(webinarData)
  const isFuture = webinar.StatusId === StatusVocabulary.FUTURE

  const place = isFuture ? PLACEFLAG_FUTURE : PLACEFLAG_LIVE
  const lectorsData = useLectorsSubscription(webinar.Lecturs, place)
  const seoTitle = `Вебинар: ${webinar.name}`

  useEffect(() => {
    setWebinar(webinarData)
  }, [webinarData.id])

  useEffect(() => {
    setSEOData((SEOContext: ISEOContext) => ({
      ...SEOContext,
      place: AnalyticWebinarPlace[webinar?.StatusId],
    }))
  }, [webinar.StatusId])

  useEffect(() => {
    if (!statisticSocket?.sendEvent || isFuture) return
    statisticSocket?.sendEvent(SocketEvents.ACTIVE_WEBINAR)
  }, [statisticSocket, statisticSocket?.sendEvent, isFuture])

  return (
    <>
      <Head>
        <title>{seoTitle}</title>
      </Head>
      <WebinarSocketWrap
        webinarData={webinar}
        setWebinar={setWebinar}
        subscribeAll={lectorsData.subscribeAll}
      >
        {isFuture ? (
          <WebinarFuture dataset={webinar} />
        ) : (
          <WebinarActive dataset={webinar} lectorsData={lectorsData} />
        )}
      </WebinarSocketWrap>
    </>
  )
}

export default WebinarWithSocket
